import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { statuses, statusClass, statusDisplayLabels, statusSubLabels } from 'payments/translations';
import styles from './index.module.css';

const i18n = (value) => statuses[value];

const AmountMobile = ({ value }) => {
  const status = value.get('status');
  const amount = value.get('amount');
  const price = amount?.get('value');
  const currency = amount?.get('currency');

  const statusLabel = statusClass[status];
  const subLabel = statusSubLabels[status];
  const className = classNames(styles.status, styles[statusLabel]);

  return (
    <div className={classNames(styles.statusAmount, { [styles.statusAmountAuto]: !!subLabel })}>
      <span className={className}>{statusDisplayLabels[status] || i18n(status)}</span>
      {subLabel && <span className={styles.statusSubtext}>{subLabel}</span>}
      <span className={styles.currencyMobile}>{`${price} ${currency}`}</span>
    </div>
  );
};

AmountMobile.propTypes = {
  value: PropTypes.instanceOf(Map).isRequired,
};

export default AmountMobile;
